<script setup>
import { onUnmounted, ref } from 'vue'
import { pronounce, pronunciationOwner, stopPronunciation } from '../services/pronunciation'

const props = defineProps({ term: { type: String, required: true }, phonetics: { type: Array, default: () => [] } })
const owner = Symbol('pronunciation')
const error = ref('')
async function play() {
  error.value = ''
  if (pronunciationOwner.value === owner) { stopPronunciation(owner); return }
  try { await pronounce(owner, props.term, props.phonetics, message => { error.value = message }) }
  catch (err) { error.value = err.message }
}
onUnmounted(() => stopPronunciation(owner))
</script>

<template>
  <div class="pronunciation-control">
    <button type="button" class="btn btn-light" :aria-label="`${pronunciationOwner === owner ? 'Dừng đọc' : 'Nghe phát âm'} ${term}`" @click="play">{{ pronunciationOwner === owner ? '■ Dừng' : '🔊 Nghe phát âm' }}</button>
    <span v-if="error" class="pronunciation-error" role="alert">{{ error }}</span>
  </div>
</template>

<style scoped>
.pronunciation-control { display: grid; gap: 8px; justify-items: start; }
.pronunciation-error { color: #9c4639; font-size: 12px; line-height: 1.6; }
</style>
